import { api } from '../common/api'

export const forgotUserSendSMS = (params: Pick<AllParams, 'nric'>) => api.get<Pick<AllParams, 'fuId' | 'tel'>>('/customer/forgot/id/sms', { params })

export const forgotUserSMSVerify = (params: Pick<AllParams, 'sms' | 'fuId'>) => api.post<{ userId: string }>('/customer/forgot/id/submit', params)

export const forgotUserUpdate = (params: Pick<AllParams, 'rnpwd' | 'npwd' | 'fuId'>) => api.post<null>('/customer/forgot/id/update', params)

export const nricValidation = (params: Pick<AllParams, 'nric'>) => api.get('/customer/forgot/id/verification', { params, hideMsg: true })